<template>
  <ul class="navbar">
    <li>
      <router-link  to="/" class="navbar__item" exact>
        <i class="navbar__item-icon icon-dashboard"></i>
        <span class="navbar__item-title">{{ $t('nav.dashboard') }}</span>
      </router-link>
    </li>
    <li v-if="isUser() && this.user.paymentModuleEnabled && this.user.paymentMenuVisible">
      <router-link to="/payment" class="navbar__item" exact>
        <i class="navbar__item-icon icon-credit-card"></i>
        <span class="navbar__item-title">{{ $t('nav.payment') }}</span>
      </router-link>
    </li>
    <li v-if="hasPermitPacks()">
      <router-link  to="/users" class="navbar__item">
        <i class="navbar__item-icon icon-users"></i>
        <span class="navbar__item-title">{{ $t('nav.users') }}</span>
      </router-link>
    </li>
    <li v-if="isLandlord()">
      <router-link  to="/tenants" class="navbar__item">
        <i class="navbar__item-icon icon-user"></i>
        <span class="navbar__item-title">{{ $t('nav.tenants') }}</span>
      </router-link>
    </li>
    <li v-if="isLandlord() || isTenant()">
      <router-link  to="/products" class="navbar__item">
        <i class="navbar__item-icon icon-product"></i>
        <span class="navbar__item-title">{{ $t('common.products') }}</span>
      </router-link>
    </li>
    <li v-if="isLandlord()">
      <router-link  to="/users" class="navbar__item">
        <i class="navbar__item-icon icon-users"></i>
        <span class="navbar__item-title">{{ $t('nav.users') }}</span>
      </router-link>
    </li>
    <li v-if="isLandlord()">
      <router-link  to="/permits" class="navbar__item">
        <i class="navbar__item-icon icon-card"></i>
        <span class="navbar__item-title">{{ $t('nav.permits') }}</span>
      </router-link>
    </li>
    <li v-if="isLandlord() || hasGuestParking()">
      <router-link  to="/parkings" class="navbar__item">
        <i class="navbar__item-icon icon-parking-clock"></i>
        <span class="navbar__item-title">{{ $t('nav.parkings') }}</span>
      </router-link>
    </li>
    <li v-if="isLandlord() || hasGuestParking()">
      <router-link  to="/blacklist" class="navbar__item">
        <i class="navbar__item-icon icon-ban"></i>
        <span class="navbar__item-title">{{ $t('common.blacklist') }}</span>
      </router-link>
    </li>
    <li v-if="isSuperAdmin() && isLandlord()">
      <router-link  to="/landlords" class="navbar__item">
        <i class="navbar__item-icon icon-user-secret" aria-hidden="true"></i>
        <span class="navbar__item-title">{{ $t('nav.landlords') }}</span>
      </router-link>
    </li>
    <li v-if="isSuperAdmin() && isLandlord()">
      <router-link  to="/zones" class="navbar__item">
        <i class="navbar__item-icon icon-map"></i>
        <span class="navbar__item-title">{{ $t('nav.zones') }}</span>
      </router-link>
    </li>
    <li v-if="isSuperAdmin() && isLandlord()">
      <router-link  to="/maps" class="navbar__item">
        <i class="navbar__item-icon icon-globe"></i>
        <span class="navbar__item-title">{{ $t('nav.maps') }}</span>
      </router-link>
    </li>
    <li v-if="isSuperAdmin() || isLandlord()">
      <router-link  to="/audit" class="navbar__item">
        <i class="navbar__item-icon icon-audit"></i>
        <span class="navbar__item-title">{{ $t('nav.audit') }}</span>
      </router-link>
    </li>
    <li v-if="isSuperAdmin() || isLandlord() || isTenant()">
      <router-link to="/report" class="navbar__item">
        <i class="navbar__item-icon icon-report"></i>
        <span class="navbar__item-title">{{ $t('nav.report') }}</span>
      </router-link>
    </li>
  </ul>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'nav-bar',
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      user: 'user/user/user'
    })
  },
};
</script>

<style lang="scss" scoped>

@import '~styles/variables.scss';

  .navbar {
    width: 100px;
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    list-style: none;

    @media screen and (max-width: 520px) {
      width: 0;
      transition: all 225ms ease-in-out;
    }
  }

  .navbar a {
    text-decoration: none;
  }

  .navbar__item {
    height: 100px;
    background-color: var(--black);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transition: all 325ms ease-in-out;
    text-align: center;
    padding-left: 10px;
    padding-right: 10px;
    width: 100px;

    &:hover {
      transition: all 325ms ease-in-out;
      background-color: lighten(#000, 30%);
    }

  }

  .navbar__item.active {
    background: linear-gradient(to right, var(--black) 50%, var(--brand-orange) 50%);
    background-size: 200% 100%;
    background-position: right bottom;
    transition: all 325ms ease-in-out;

    &:hover {
      color: darken($brand-orange, 12.5%);
      transition: all 325ms ease-in-out;

      * {
        transition: all 225ms ease-in-out;
        color: darken(#fff, 22.5%);
      }
    }

  }

  .navbar__item-icon {
    display: block;
    height: 50px;
    width: 50px;
  }
  .navbar__item-title {
    text-transform: uppercase;
    color: var(--white);
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/NavBar.vue